import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {AppLanguage, detectInitialLanguage, sanitizeLanguage} from '../../i18n/config';

type PreferencesState = {
  language: AppLanguage;
};

const initialState: PreferencesState = {
  language: detectInitialLanguage(),
};

export const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<AppLanguage>) => {
      state.language = sanitizeLanguage(action.payload);
    },
  },
});

export const {setLanguage} = preferencesSlice.actions;

